"use strict";

import "./CriticalValueNotificationConfigForm.css";

import React from "react";
import ReactDOM from "react-dom";

import Form from "vwa/components/Form";
import MultiSelector from "vwa/components/MultiSelector";
import Checkbox from "vwa/components/Checkbox";
import Select from "vwa/components/Select";
import InputWithUnit from "vwa/components/InputWithUnit";
import Input from "vwa/components/Input";

import getModificationsByRef from "vfu/getModificationsByRef";

import createWellQuantity from "vwa/quantity/createWellQuantity";
import getOriginalValueFromWellQuantity from "vwa/quantity/getOriginalValueFromWellQuantity";
import {getUnitAssignment} from "./../../../utils/user";

import {getUserId} from "./../../../utils/user";
import {getEventDescriptorFromNotificationConfig} from "./../../../utils/notification";

import lang from "vwa/lang";

export default class CriticalValueNotificationConfigForm extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = this.getDefaultState();
	}
	
	componentDidUpdate(_, prevState){
		const modifications = getModificationsByRef(prevState, this.state);
		
		if(!modifications){
			return;
		}
		
		this.props.onChange(this.getEventDescriptor(), this.getNotificationConfig());
	}
	
	clear(){
		this.setState(this.getDefaultState());
		this.refs.vehicleSelector.clear();
	}
	
	getConvertedTime(timestamp){
		let value = timestamp / 1000;
		let unit = "sec";
		
		if(value != 0){
			if( parseInt(value / 60, 10) == value / 60 ){
				value = value / 60;
				unit = "min"; 
			}
			
			if( parseInt(value / 60, 10) == value / 60 ){
				value = value / 60;
				unit = "hour"; 
			}
		}
		
		return {value, unit};
	}
	
	getTimeInMilisecsFromConvertedTime(convertedTime){
		if(convertedTime.unit == "sec"){
			return convertedTime.value * 1000;
		}
		if(convertedTime.unit == "min"){
			return convertedTime.value * 1000 * 60;
		}
		if(convertedTime.unit == "hour"){
			return convertedTime.value * 1000 * 60 * 60;
		}
		return null;
	}
	
	getParsedOperands(){
		const unitAssignment = getUnitAssignment();
		
		let parsedOperands = [];
		if(this.state.dataType.representationType == "Integer"){
			parsedOperands = this.state.operands.map(
				e => !!e ? getOriginalValueFromWellQuantity({value: parseInt(e, 10), unit: unitAssignment[this.state.dataType.applicationType]}, this.state.dataType.unit, this.state.dataType.representationType) : ""
			);
		}
		if(this.state.dataType.representationType == "Float"){
			parsedOperands = this.state.operands.map(
				e => !!e ? getOriginalValueFromWellQuantity({value: parseFloat(e), unit: unitAssignment[this.state.dataType.applicationType]}, this.state.dataType.unit, this.state.dataType.representationType) : ""
			);
		}
		
		if(parsedOperands.some(e => !Number.isFinite(e))){
			return null;
		}
		
		if(this.state.operator != "between" && this.state.operator != "notbetween"){
			parsedOperands = [parsedOperands[0]];
		}
		
		return parsedOperands;
	}
	
	getWellQuantifiedOperands(operands, dataType){
		return operands.map(operand => createWellQuantity(getUnitAssignment(), dataType.applicationType, operand, dataType.unit, dataType.representationType).value);

	}
	
	getDefaultVehiclesFromAssignmentDescriptor(assignmentDescriptor){
		if(assignmentDescriptor.user){
			return null;
		}
		else{
			return assignmentDescriptor.carriers;
		}
	}
	
	getDefaultState(){
		const eventDescriptor = this.props.notificationConfig ? getEventDescriptorFromNotificationConfig(this.props.notificationConfig) : null;
		
		const dataTypeId = this.props.notificationConfig ? eventDescriptor.dataType : this.props.dataTypes[0]._id;
		const dataType = this.props.dataTypes.find(dt => dt._id == dataTypeId);
		
		return {
			dataType,
			vehicles: 			this.props.notificationConfig ? this.getDefaultVehiclesFromAssignmentDescriptor(eventDescriptor.carriers) : null,
			debounceTimeActive: this.props.notificationConfig ? eventDescriptor.debounceTime > 0 : false,
			debounceTimeValue: 	this.props.notificationConfig ? this.getConvertedTime(eventDescriptor.debounceTime).value : 0,
			debounceTimeUnit: 	this.props.notificationConfig ? this.getConvertedTime(eventDescriptor.debounceTime).unit : "sec",
			operands: 			this.props.notificationConfig ? this.getWellQuantifiedOperands(eventDescriptor.operands, dataType) : [0],
			operator: 			this.props.notificationConfig ? eventDescriptor.operator : "eq",
			web: 				this.props.notificationConfig ? this.props.notificationConfig.web : true,
			email: 				this.props.notificationConfig ? this.props.notificationConfig.email : false,
			sms: 				this.props.notificationConfig ? this.props.notificationConfig.sms : false
		};
	}
	
	getVehicleOptions(){
		if(this.props.vehicles){
			return this.props.vehicles.map(vehicle => ({
				value: vehicle._id,
				label: vehicle.name
			}));
		}
		else{
			return [];
		}
	}
	
	getVehiclesAssignmentDescriptor(){
		return({
			user: this.state.vehicles ? null : getUserId(),
			type: "CarrierAssignmentDescriptor",
			carriers: this.state.vehicles ? this.state.vehicles : null
		});
	}
	
	getEventDescriptor(){
		let eventDescriptor = {
			carriers:			this.getVehiclesAssignmentDescriptor(),
			dataType: 			this.state.dataType._id,
			operator: 			this.state.operator,
			debounceTime: 		this.state.debounceTimeActive ? this.getTimeInMilisecsFromConvertedTime({value: this.state.debounceTimeValue, unit: this.state.debounceTimeUnit}) : 0,
			operands: 			this.getParsedOperands(),
			type: 				"CriticalScalarStateDescriptor"
		};
		
		if(this.props.notificationConfig){
			eventDescriptor = Object.assign(eventDescriptor, {_id: this.props.notificationConfig.descriptor});
		}
		
		return eventDescriptor;
	}
	
	getNotificationConfig(){
		return {
			web: 	this.state.web,
			email: 	this.state.email,
			sms: 	this.state.sms
		};
	}
	
	renderOperandsInput(){
		const unitAssignment = getUnitAssignment();
		const conditionUnit = unitAssignment[this.state.dataType.applicationType];
		
		if(this.state.operator == "between" || this.state.operator == "notbetween"){
			return(
				<div className="OperandInputContainer">
					<Input
						id="firstOperandInput"
						type="number"
						value={this.state.operands[0]}
						onChange={evt => this.setState({operands: [evt.target.value, this.state.operands[1]]})}
						typingTimeout={3000}
					/>
					<label>{lang._AND}</label>
					<InputWithUnit
						id="secondOperandInput"
						label={conditionUnit}
						value={this.state.operands[1]}
						onChange={evt => this.setState({operands: [this.state.operands[0], evt.target.value]})}
						typingTimeout={3000}
					/>
				</div>
			);
		}
		else{
			return(
				<div className="OperandInputContainer">
					<InputWithUnit
						id="singleOperandInput"
						label={conditionUnit}
						value={this.state.operands[0]}
						onChange={evt => this.setState({operands: [evt.target.value]})}
						typingTimeout={3000}
					/>
				</div>
			);
		}
	}
	
	render(){		
		return(
			<Form className="CriticalValueNotificationConfigForm">
				<MultiSelector
					title={lang.VEHICLES}
					ref="vehicleSelector"
					options={this.getVehicleOptions()}
					onChange={(vehicles, all) => this.setState({vehicles: all ? null : vehicles})}
					defaultValue={this.state.vehicles}
				/>
				<div className="ConditionContainer">
					<label className="Title">{lang.CONDITION}</label>
					<div>
						<Select
							id="dataTypeSelect"
							value={this.state.dataType._id}
							onChange={evt => this.setState({dataType: this.props.dataTypes.find(dt => dt._id == evt.target.value)})}
						>
							{this.props.dataTypes.map(dataType => {
									return(<option key={dataType._id} value={dataType._id}>{lang["DATA_TYPE_" + dataType._id]}</option>)
								})
							}
						</Select>
						<Select
							id="relationSelect"
							value={this.state.operator}
							onChange={evt => this.setState({operator: evt.target.value})}
							required={true}
						>
							<option value="eq">=</option>
							<option value="ne">≠</option>
							<option value="gt">&gt;</option>
							<option value="gte">≥</option>
							<option value="lt">&lt;</option>
							<option value="lte">≤</option>
							<option value="between">{lang._BETWEEN}</option>
							<option value="notbetween">{lang._NOT_BETWEEN}</option>
						</Select>
						{this.renderOperandsInput()}
					</div>
					<div>
						<Checkbox
							checked={this.state.debounceTimeActive}
							onChange={value => this.setState({debounceTimeActive: value})}
						/>
						<label className={!this.state.debounceTimeActive ? "Inactive" : ""}>{lang.SEND_NOTIFICATION_IF_THE_CONDITION_IS_FULFILLED_FOR}</label>
						<Input
							id="debounceTimeInput"
							disabled={!this.state.debounceTimeActive}
							onChange={evt => this.setState({debounceTimeValue: evt.target.value})}
							type="number"
							value={this.state.debounceTimeValue}
							typingTimeout={3000}
						/>
						<Select
							id="timeUnitSelect"
							disabled={!this.state.debounceTimeActive}
							value={this.state.debounceTimeUnit}
							onChange={evt => this.setState({debounceTimeUnit: evt.target.value})}
							required={true}
						>
							<option value="sec">{this.state.debounceTimeValue == 1 ? lang._SECOND : lang._SECONDS}</option>
							<option value="min">{this.state.debounceTimeValue == 1 ? lang._MINUTE : lang._MINUTES}</option>
							<option value="hour">{this.state.debounceTimeValue == 1 ? lang._HOUR : lang._HOURS}</option>
						</Select>
					</div>
				</div>
				<div>
					<label className="Title">{lang.SEND_NOTIFICATIONS_VIA}</label>
					<div className="CheckboxContainer">
						<Checkbox
							checked={this.state.web}
							onChange={value => this.setState({web: value})}
						/>
						<label>{lang.WEB}</label>
						<Checkbox
							checked={this.state.email}
							onChange={value => this.setState({email: value})}
						/>
						<label>{lang.EMAIL}</label>
						<Checkbox
							checked={this.state.sms}
							onChange={value => this.setState({sms: value})}
						/>
						<label>{lang.TEXT_MESSAGE}</label>
					</div>
				</div>
			</Form>
		);
	}
	
}

CriticalValueNotificationConfigForm.propTypes = {
	dataTypes:			React.PropTypes.array,
	vehicles:			React.PropTypes.array,
	onChange: 			React.PropTypes.func,
	notificationConfig: React.PropTypes.object
};

CriticalValueNotificationConfigForm.defaultProps = {
	dataTypes:			[],
	vehicles: 			[],
	onChange: 			(getEventDescriptor, NotificationConfig) => {},
	notificationConfig: null
};


// WEBPACK FOOTER //
// ./src/view/CriticalValueNotifications/CriticalValueNotificationConfigForm/CriticalValueNotificationConfigForm.jsx